import '@/assets/styles/base.scss';
import { preloadPassport } from '../utils/passport';

import App from './App-introA.svelte';

import { setupErrorMonitor } from '@/utils/errorMonitor';
import { reportP3, updateUid } from '@/utils/fmpTrack';
import { smallFlowInit } from '@/utils/smallFlow';

updateUid();
// 初始化错误监控
setupErrorMonitor();
void preloadPassport().catch((error) => {
    console.error('[preloadPassport]', error);
});
smallFlowInit();
reportP3();

const appDom = document.getElementById('app');

if (appDom) {
    appDom.innerHTML = '';
}

const app = new App({
    target: document.getElementById('app')!
});

export default app;
